export default "__VITE_ASSET__f7254837__"